import Table from '@mui/joy/Table';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';

interface ImportedTestsValidationTable {
  wrongUrls: wrongUrlError[];
}

interface wrongUrlError {
  url: string;
  message: string;
}

const ImportedTestsValidationTable = ({ wrongUrls }: ImportedTestsValidationTable) => {
  if (!wrongUrls.length) return;

  return (
    <Box mb={5}>
      <Typography mt={0} color="danger">
        Import failed, {wrongUrls.length} invalid URL(s) found. Please check the following URL(s) and try again.
      </Typography>
      <Box sx={{ maxHeight: 250, height: '100%', overflowY: 'scroll', marginBottom: 2 }}>
        <Table sx={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th style={{ width: '10%' }}>#</th>
              <th style={{ width: '50%' }}>Link</th>
              <th style={{ width: '40%' }}>Message</th>
            </tr>
          </thead>
          <tbody>
            {wrongUrls.map((error, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{error.url}</td>
                <td>{error.message}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default ImportedTestsValidationTable;
